function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#302C3B",
  d: "M80 5.333C80 2.833 77.167 0 74.667 0H5.333C2.833 0 0 2.833 0 5.333v53.334h80V5.333z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CFD8DD",
  d: "M0 58.667v2.666c0 2.5 2.833 5.334 5.333 5.334h69.334c2.5 0 5.333-2.834 5.333-5.334v-2.666H0zM29.333 72c0 3.472-10.666 2.667-10.666 2.667h42.666S50.667 75.472 50.667 72v-5.333H29.333V72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#99A8AE",
  d: "M29.333 72l21.334-2.667v-2.666H29.333z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4E5E67",
  d: "M5.333 5.333h69.333v48H5.333z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6E8189",
  d: "M74.667 53.333h-7.263l-36.979-48h44.242z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 61.251,
  r: 4,
  fill: "#99A8AE"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#99A8AE",
  d: "M18.667 74.667h42.667V80H18.667z"
}));

var SvgLocalfilesIco = function SvgLocalfilesIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocalfilesIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/localfiles_ico.e0934df6.svg";
export { ForwardRef as ReactComponent };